/* eslint-disable prettier/prettier */
import { get as _get, isString } from 'lodash-es'

function getDefaultState() {
  return {
    appName: '',
    modelName: '',
    modelType: '',
    ownership: null,
    sortOrder: null,
    sortId: null,
    pageSize: null,
    visibleColumnIds: null,
    search: null,
    filters: null,
  }
}

const actions = {
  async initModule({ dispatch }, payload) {
    const { vuexPrefix, appName, modelName, modelType } = payload
    await dispatch('initMetaKeys', { appName, modelName, modelType })
    dispatch('initSettings', vuexPrefix)
  },

  initMetaKeys({ state }, { appName, modelName, modelType }) {
    Object.assign(state, { appName, modelName, modelType })
  },

  initSettings({ commit, getters, rootGetters }, vuexPrefix) {
    const serverListSettings = getters.serverListSettings(vuexPrefix)

    let legacyServerSettings = {}

    if (serverListSettings.sort) {
      if (serverListSettings.sort.order)
        legacyServerSettings['sortOrder'] = serverListSettings.sort.order
      if (serverListSettings.sort.columnId)
        legacyServerSettings['sortId'] = serverListSettings.sort.columnId
      delete serverListSettings['sort']
    }

    if (serverListSettings.pagination && serverListSettings.pagination.limit) {
      legacyServerSettings['pageSize'] = serverListSettings.pagination.limit
      delete serverListSettings['pagination']
    }
    if (serverListSettings.columns && serverListSettings.columns.length) {
      legacyServerSettings['visibleColumnIds'] = serverListSettings.columns
        .filter((c) => c.isVisible)
        .map((c) => c.id)
      delete serverListSettings['columns']
    }
    if (
      isString(serverListSettings?.ownership) &&
      serverListSettings?.ownership?.toLowerCase() === 'group'
    ) {
      legacyServerSettings['ownership'] =
        rootGetters['auth/loggedInUserPrimaryGroup']
      delete serverListSettings['ownership']
    }
    commit('INIT_SETTINGS', {
      ...legacyServerSettings,
      ...serverListSettings,
    })
  },
}

const mutations = {
  INIT_SETTINGS(state, settings) {
    Object.assign(state, settings)
  },
}

const getters = {
  rawSettings: (state, getters, rootState, rootGetters) => {
    return rootGetters['settings/rawSettings']
  },
  serverListSettings: (state, getters) => (vuexPrefix) => {
    const settingsPath = [
      vuexPrefix,
      state.appName,
      state.modelName,
      state.modelType,
      'list',
    ].filter((el) => el !== '')
    return _get(getters.rawSettings, settingsPath, {})
  },
  nonEmptySettings: (state) => {
    const ownership = state.ownership?.name ? state.ownership : null
    return {
      ...(ownership && { ownership }),
      ...(state.sortId && { sortId: state.sortId }),
      ...(state.sortOrder && { sortOrder: state.sortOrder }),
      ...(state.pageSize &&
        state.pageSize > -1 && { pageSize: state.pageSize }),
      ...(state.search && { search: state.search }),
      ...(state.filters &&
        Object.keys(state.filters).length && {
          filters: state.filters,
        }),
      ...(state.visibleColumnIds &&
        state.visibleColumnIds.length && {
          visibleColumnIds: state.visibleColumnIds,
        }),
    }
  },
}

const serverSettings = {
  namespaced: true,
  state: () => getDefaultState(),
  actions,
  getters,
  mutations,
}

export default serverSettings
